module.exports = __webpack_public_path__ + "static/media/insta.d9e73c42.png";